import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { TooltipProvider } from '@/components/ui/tooltip';
import App from './App';
import { useAuthStore } from '@/stores/auth-store';
import { queryClient } from '@/lib/query-client';
import './i18n';
import './index.css';

// Clear all cached query data on logout (or session expiry / idle timeout).
// Prevents stale staff-scoped data (e.g. cached /users or /clients responses)
// from leaking into a subsequent login as a different role in the same tab.
useAuthStore.subscribe((state, prev) => {
  if (prev.isAuthenticated && !state.isAuthenticated) {
    queryClient.clear();
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <TooltipProvider delayDuration={300}>
          <App />
        </TooltipProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
